import axios from "axios";

// Simple ID generator
const generateId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const getSessionId = () => {
    let sessionId = localStorage.getItem("session_id");
    if (!sessionId) {
        sessionId = generateId();
        localStorage.setItem("session_id", sessionId);
    }
    return sessionId;
};

export const resetSessionId = () => {
    const newSessionId = generateId();
    localStorage.setItem("session_id", newSessionId);
    return newSessionId;
};

export const trackActivity = async (payload) => {
    try {
        // console.log("[ActivityTracker] trackActivity called for:", payload);
        const username = localStorage.getItem("username");

        if (!username) {
            // console.log("[ActivityTracker] No username found in localStorage. Skipping.");
            return;
        }

        const sessionId = getSessionId();
        const toLocalISOString = (date) => {
            const offset = date.getTimezoneOffset() * 60000; // offset in milliseconds
            const localISOTime = (new Date(date - offset)).toISOString().slice(0, -1);
            return localISOTime;
        };

        const clientTimestamp = toLocalISOString(new Date());

        let requestBody = {
            username: username,
            session_id: sessionId,
            client_timestamp: clientTimestamp
        };

        if (typeof payload === 'string') {
            // Backward compatibility for simple strings
            requestBody.action = payload;
            requestBody.activity = payload;
        } else {
            // Structured data
            requestBody.tab_name = payload.tab_name;
            requestBody.action = payload.action;
            requestBody.metadata = payload.metadata;
            // Legacy fallback construction
            requestBody.activity = payload.activity || `${payload.tab_name || 'General'}: ${payload.action}`;
        }

        // console.log("[ActivityTracker] Sending request:", requestBody);

        // Use /api/track endpoint (via proxy /api -> 8003)
        // Adjusting path to match proxy setup: 
        // package.json proxy says "/api" -> "" (rewrites to root of 8003)
        // so axios.post('/api/track') hits http://localhost:8003/track
        await axios.post('/api/track', requestBody);

    } catch (error) {
        console.error("[ActivityTracker] Failed to track:", error);
    }
};
